// S04 에서 채울 화면(주간·학생·현황·관리) 자리 — 내비 목적지가 비어 보이지 않게 안내만
import { Icon } from "../ui/icons";
import { TITLES } from "../ui/Shell";

export function Soon({ name }: { name: string }) {
  return (
    <div className="page">
      <div className="soon">
        <h2>{TITLES[name] ?? "준비 중"}</h2>
        <p className="muted">이 화면은 다음 단계에서 열립니다. 지금은 대시보드·개별일정 등록·당일 클리닉을 쓸 수 있습니다.</p>
        <div className="soon-links">
          <a className="btn btn-primary" href="#/today"><Icon name="today" size={20} /> 당일 클리닉</a>
          <a className="btn" href="#/register"><Icon name="plus" size={20} /> 개별일정 등록</a>
        </div>
      </div>
    </div>
  );
}
